module.exports = __webpack_public_path__ + "img/cloud-computing.f820ed87.svg";